import type { SyncClient } from '@machs/shared';
import { mediaUrl } from './api';
import { localMediaUrl } from './storage';

/** Anzeige-URL eines Bild-Mediums (lokal, solange es noch nicht hochgeladen ist). */
export function imageUrl(mediaId: string | null | undefined): string | null {
  if (!mediaId) return null;
  return localMediaUrl(mediaId) ?? mediaUrl(mediaId);
}

/** Bild lokal vormerken und seine Medien-ID liefern. */
export async function queueImageFile(client: SyncClient, file: File): Promise<string> {
  const url = URL.createObjectURL(file);
  let width: number | null = null;
  let height: number | null = null;
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    width = img.naturalWidth;
    height = img.naturalHeight;
  } catch {
    // Maße sind optional
  } finally {
    URL.revokeObjectURL(url);
  }
  return client.queueImage({ file, fileName: file.name, mime: file.type || null, width, height });
}
